// Admin workbench section list (console shell v3, Wave 1). Feeds the ShellSubrail jump
// groups, so it must offer exactly the sections the page renders for this viewer - a jump
// to a section that is not on the page is a dangling promise. Order matches the page.

export interface AdminSectionSpec {
  id: string;
  label: string;
}

/** Sections are permission-shaped: the same keys that render a section list it here. */
export function buildAdminSections(
  canViewPolicy: boolean,
  canManagePermissions: boolean,
  adminBrandingEnabled = true,
): AdminSectionSpec[] {
  const sections: AdminSectionSpec[] = [];

  if (canViewPolicy) {
    sections.push(
      { id: "admin-policies", label: "Policies" },
      { id: "admin-duty", label: "Duty" },
      { id: "admin-mobile-flags", label: "Mobile flags" },
      { id: "admin-alert-channels", label: "Alerts" },
    );
  }

  // Every signed-in member owns their own additive preferences, so this one is never gated -
  // for a member without policy.view it is the first section on the page.
  sections.push({ id: "admin-my-alert-channels", label: "My alerts" });

  if (canViewPolicy) {
    sections.push({ id: "admin-consent", label: "Consent" });
  }

  sections.push({ id: "admin-members", label: "Members" });
  // PRD-001AE: gated on the same key that renders the section. Sits between Members and
  // Devices because that is the page order, and because "who holds which role" reads
  // straight on from the roster.
  if (canManagePermissions) {
    sections.push({ id: "admin-permissions", label: "Permissions" });
  }
  sections.push(
    { id: "admin-devices", label: "Devices" },
    { id: "admin-audit", label: "Audit" },
  );
  if (adminBrandingEnabled) {
    sections.push({ id: "admin-branding", label: "Branding" });
  }
  sections.push(
    { id: "admin-commercial", label: "Commercial" },
    { id: "admin-release", label: "Release" },
  );

  return sections;
}
